<template>
  <div id="ArticlePage">
    <div v-if="article" class="article-content">
      <h2>{{ article.title }}</h2>
      <div v-if="article.embed_code" v-html="article.embed_code" class="video-container"></div>
      <img v-else :src="article.image_url" alt="">
      <p v-html="decodeData(article.body)"></p>
    </div>
    <div v-else-if="errorMsg">
      <h2>{{errorMsg}}</h2>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../config/constants";

export default {
  name: "ArticlePage",
  data() {
    return {
      article: null,
      errorMsg: ""
    }
  },
  computed: {
    passedArticleId() {
      return this.$route.params.articleId;
    },
  },
  mounted() {
    this.getArticle(this.passedArticleId)
  },
  methods: {
    async getArticle(articleId) {
      const payload = {
          user_id: this.$store.getters.user_id,
          article_id: articleId,
        }
      const res = await axios.post(config.api_env + '/application/api/u/sapphire/article/get-article', payload, config.options)
      if (res.data.success && res.data.article) {
        this.article = res.data.article
      } else if (res.data.err && res.data.err.includes("Article not found")) {
        this.errorMsg = 'Article not found'
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
      }
    },
    decodeData(data) {
      try {
        return atob(data);
      } catch (error) {
        return data;
      }
    }
  }
}
</script>

<style lang="less">
#ArticlePage {
  background-color: #fff;
  padding: 20px;
  color: #000;

  .article-content {
    display: flex;
    flex-direction: column;
    max-width: 800px;
    height: 100%;
    margin: 0 auto;
  }

  img {
    align-self: center;
    width: 100%;
    max-width: 320px;
    margin-bottom: 20px;
    border-radius: 8px;
  }

  h2 {
    color: #36383A;
    font-family: "Raptor V3 Black";
    font-size: 3.2rem;
  }

  p {
    font-size: 1.8rem;
    color: #343C3D;
  }

  iframe {
    position: static !important;
    width: 100%;
  }

  .video-container {
    width: 100%;
    height: 100%;
    align-self: center;
    padding: 40px;
  }
}
</style>